import { render, staticRenderFns } from "./HoverCard.vue?vue&type=template&id=873e1348&scoped=true"
import script from "./HoverCard.vue?vue&type=script&lang=js"
export * from "./HoverCard.vue?vue&type=script&lang=js"
import style0 from "./HoverCard.vue?vue&type=style&index=0&id=873e1348&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873e1348",
  null
  
)

export default component.exports